import PropTypes from 'prop-types';
import React from 'react';
import ArchiveIcon from '../../shared/Icons/ArchiveIcon';
import BankIcon from '../../shared/Icons/BankIcon';
import CalendarIcon from '../../shared/Icons/CalendarIcon';
import CheckCircle from '../../shared/Icons/CheckCircle';
import CreditCardIcon from '../../shared/Icons/CreditCardIcon';
import DocumentIcon from '../../shared/Icons/DocumentIcon';
import SearchIcon from '../../shared/Icons/SearchIcon';
import TicketIcon from '../../shared/Icons/TicketIcon';
import TrendUpIcon from '../../shared/Icons/TrendUpIcon';
import UsersIcon from '../../shared/Icons/UsersIcon';
import XCircle from '../../shared/Icons/XCircle';

// Substitutes from bundles/shared/Icons rather than the design's own glyphs — the set has no
// shield, ban, bell, scales or cart, and drawing five one-off SVGs for one page is a worse
// trade than a near-miss from the set every other page already uses.
export const ICONS = {
  // model explainer
  order: CreditCardIcon,
  signals: SearchIcon,
  review: ArchiveIcon,
  // rules
  issuer: BankIcon,
  events: CalendarIcon,
  ticket: TicketIcon,
  score: TrendUpIcon,
  action: CheckCircle,
  block: XCircle,
  buyers: UsersIcon,
  digest: DocumentIcon,
};

// No width/height: XCircle and CheckCircle derive their viewBox from the width prop, so
// passing one silently crops them. CSS sizes the svg instead. `fill` is the stroke colour in
// this icon set, and three of them default to a hardcoded brand colour — currentColor lets
// the tile own it.
const AutomationIcon = ({ name }) => {
  const Icon = ICONS[name];
  if (!Icon) return null;

  return <Icon fill="currentColor" />;
};

AutomationIcon.propTypes = { name: PropTypes.oneOf(Object.keys(ICONS)).isRequired };

export default AutomationIcon;
